import React from "react";
import banner from "./Assent/banner.jpg";

function Banner() {
  return (
    <div
      style={{
        width: "100%",
        height: "50vh",
        background: "black",
        overflow: "hidden",
        marginTop: "0px",
      }}
      className="banner-hero"
    >
      <img
        src={banner}
        alt="banner"
        className="img-fluid"
        style={{
          height: "50vh",
          width: "100%",
          objectFit: "cover",
          transform: "scale(1.2)",
        }}
      />
    </div>
  );
}

export default Banner;
